import {
  EditBase,
  Form,
  useDataProvider,
  useNotify,
  type Identifier,
} from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import {
  assertCompanyIsUnique,
  DuplicateRecordError,
} from "@/lib/duplicateIdentity";
import { CompanyInputs } from "./CompanyInputs";
import { CompanyAside } from "./CompanyAside";
import { FormToolbar } from "../layout/FormToolbar";

export const CompanyEdit = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  return (
    <EditBase
      actions={false}
      redirect="show"
      transform={async (values: {
        website?: string;
        name?: string;
        id?: Identifier;
      }) => {
        if (values.website && !values.website.startsWith("http")) {
          values.website = `https://${values.website}`;
        }
        try {
          await assertCompanyIsUnique(dataProvider, {
            id: values.id,
            name: values.name,
          });
        } catch (error) {
          if (error instanceof DuplicateRecordError) {
            notify(error.message, { type: "warning" });
          }
          throw error;
        }
        return values;
      }}
    >
      <div className="mt-2 flex gap-8">
        <Form className="flex flex-1 flex-col gap-4 pb-2">
          <Card>
            <CardContent>
              <CompanyInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>

        <CompanyAside link="show" />
      </div>
    </EditBase>
  );
};
